import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 3v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M8 3v4" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 11h16" }),
		/* @__PURE__ */ _jsx("path", { d: "M11 15h1" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 15v3" })
	]
});
export { SvgCalendar as ReactComponent };
